/** Publication millimetres convert to CSS pixels at 96 px per inch.
 * A leaf module keeps geometry helpers independent of document initialization. */
export const mmToCssPx = (mm: number) => (mm * 96) / 25.4;
